import styled, { css } from 'styled-components';
import { IButton } from './types';

export const Container = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-direction: column;
  overflow-y: auto;
  box-sizing: border-box;
  height: 360px;
`;
export const Header = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  background: #f4f4f4;
  padding: 5px;
  border-radius: 26px;
  width: 100%;
`;

export const Button = styled.button<IButton>`
  display: flex;
  gap: 5px;
  align-items: center;
  border: none;
  outline: none;

  margin: 0;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 26px;
  padding: 10px 15px;
  color: #005f47;
  ${({ isCurrent }) => {
    if (isCurrent) {
      return css`
        background: #b7ffbd;
        font-weight: 700;
      `;
    }
    return css`
      background: none;
    `;
  }}
`;

export const Content = styled.div`
  display: flex;
  overflow: auto;
  gap: 10px;
  flex-wrap: wrap;
`;

export const Option = styled.button`
  display: flex;
  gap: 10px;
  align-items: center;
  border: none;
  outline: none;

  margin: 0;
  padding: 10px;
  cursor: pointer;
  border-radius: 12px;
  padding: 10px 15px;
  background: #005f47;
  color: #fff;
  width: calc(33% - 5px);
  text-align: left;

  justify-content: space-between;
`;
